import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Utils
import { createQueryString, getParams } from '../../../../util/urlUtil';
var ARRIVAL_AVENUE_STORAGE_KEY = 'arrival_avenue';
export var getPersistedSessionArrivalAvenue = function getPersistedSessionArrivalAvenue() {
  if (!window.sessionStorage) return 'unknown';
  return window.sessionStorage.getItem(ARRIVAL_AVENUE_STORAGE_KEY);
};
var setPersistedSessionArrivalAvenue = function setPersistedSessionArrivalAvenue(arrivalAvenue) {
  if (!window.sessionStorage) return;
  return window.sessionStorage.setItem(ARRIVAL_AVENUE_STORAGE_KEY, arrivalAvenue);
};
var determineSessionArrivalAvenue = function determineSessionArrivalAvenue() {
  var params = getParams(window.location.search);

  // Invite code
  if (params.invite) return 'board invite';

  // Referral code
  if (params.referrer) return 'referral';
  var path = window.location.pathname;

  // Home page
  if (path === '/') return 'home page';

  // Sub path
  return path;
};
export var persistSessionArrivalAvenue = function persistSessionArrivalAvenue() {
  var persistedSessionArrivalAvenue = getPersistedSessionArrivalAvenue();

  // If we've already persisted the session arrival location - don't persist again
  if (persistedSessionArrivalAvenue) return;
  var arrivalAvenue = determineSessionArrivalAvenue();
  setPersistedSessionArrivalAvenue(arrivalAvenue);
};
var config = window.__config;
export var getInitialValuesFromQueryString = function getInitialValuesFromQueryString() {
  var params = getParams(window.location.search);
  return {
    onboarding: params.onboarding,
    successRedirect: params.success_redirect,
    segments: params.segments && params.segments.split(','),
    inviteCode: params.invite,
    referrerCode: params.referrer,
    marketingReferralCode: params.r || params.ref || params.referrer,
    example: params.example,
    featureFlags: params.feature_flags,
    agreeToTerms: false,
    subscribeToProductUpdates: false
  };
};
export var getSocialSignInUrl = function getSocialSignInUrl(vendor) {
  var currentQueryParams = getParams(window.location.search);
  var queryParams = createQueryString(_objectSpread(_objectSpread({
    // Pass in origin, so that users will be redirected back the page they were on when authentication fails
    origin: encodeURIComponent(window.location.href)
  }, currentQueryParams), {}, {
    "with": vendor
  }));
  return "".concat(config.appUrl, "/register-terms").concat(queryParams);
};